const CardShow = () => import('../views/CardShow');
const CardShowCover = () => import('../views/CardShowCover');
const CardResults = () => import('../views/CardResults');

const router = [
  {
    path: '/viewer/cards/:cardId(\\d+)',
    component: CardShow,
    alias: '/viewer/assignments/:cardId(\\d+)',
    props: true,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        name: 'cards.show',
        path: '',
        component: CardShowCover,
        meta: {
          requiresAuth: true,
        },
      },
      {
        name: 'cards.results',
        path: 'results',
        component: CardResults,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

export default router;
